export interface Video {
  id: number;
  title: string;
  category: string;
  image: string;
  rating: number;
  year: number;
  quality: string;
  description: string;
  duration: string;
}

export const videos: Video[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20massive%20spaceship%20approaching%20Earth%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20epic%20scale%2C%20clean%20minimalist%20composition%20on%20warm%20ivory%20background%2C%20movie%20poster%20style%20with%20Chinese%20typography%20space&width=800&height=450&seq=video-poster-01&orientation=landscape',
    rating: 9.2,
    year: 2026,
    quality: '4K',
    description: '人类面临前所未有的太阳系危机，全球联合政府启动"流浪地球计划"第三阶段，一场跨越星际的史诗冒险即将展开。',
    duration: '148分钟',
  },
  {
    id: 2,
    title: '繁花似锦',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20visual%20with%20blooming%20flowers%20and%20traditional%20architecture%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20clean%20composition%20on%20cream%20background%2C%20cinematic%20drama%20poster%20style&width=800&height=450&seq=video-poster-02&orientation=landscape',
    rating: 8.8,
    year: 2026,
    quality: '1080P',
    description: '讲述了民国时期上海滩的商界传奇故事，展现了那个年代的风云变幻与儿女情长。',
    duration: '40集',
  },
  {
    id: 3,
    title: '欢乐喜剧人·巅峰之战',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20comedy%20show%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20atmosphere%2C%20warm%20vibrant%20tones%2C%20clean%20minimalist%20background%20with%20soft%20gradient%2C%20variety%20show%20poster%20style&width=800&height=450&seq=video-poster-03&orientation=landscape',
    rating: 9.0,
    year: 2026,
    quality: '1080P',
    description: '全国顶尖喜剧人齐聚一堂，用欢笑与感动为观众带来一场视听盛宴，笑点密集全程高能。',
    duration: '12期',
  },
  {
    id: 4,
    title: '星辰大海',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20hero%20standing%20under%20a%20starry%20night%20sky%20with%20galaxy%20swirls%2C%20warm%20golden%20and%20deep%20blue%20contrast%2C%20clean%20composition%2C%20adventure%20anime%20poster%20style&width=800&height=450&seq=video-poster-04&orientation=landscape',
    rating: 9.5,
    year: 2026,
    quality: '4K',
    description: '少年为追寻传说中的星辰宝藏，踏上穿越银河的冒险之旅，途中结识伙伴，共同对抗黑暗势力。',
    duration: '24集',
  },
  {
    id: 5,
    title: '暗夜追踪',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Noir%20thriller%20movie%20visual%20with%20a%20detective%20silhouette%20in%20rainy%20city%20alley%2C%20dramatic%20lighting%20with%20warm%20neon%20accents%2C%20mysterious%20atmosphere%2C%20clean%20composition%20on%20warm%20dark%20background%2C%20thriller%20movie%20poster&width=800&height=450&seq=video-poster-05&orientation=landscape',
    rating: 8.6,
    year: 2026,
    quality: '4K',
    description: '一名私家侦探卷入连环失踪案，在暗夜中追寻真相，却发现案件背后隐藏着惊天阴谋。',
    duration: '126分钟',
  },
  {
    id: 6,
    title: '山河令·续',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20with%20two%20warriors%20on%20misty%20mountain%20peak%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20warm%20earth%20tones%2C%20clean%20minimalist%20composition%2C%20wuxia%20drama%20poster&width=800&height=450&seq=video-poster-06&orientation=landscape',
    rating: 8.9,
    year: 2026,
    quality: '1080P',
    description: '江湖风云再起，昔日侠客重出江湖，在纷乱世道中守护心中正义与挚爱之人。',
    duration: '36集',
  },
  {
    id: 7,
    title: '声入人心·第五季',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20music%20competition%20stage%20with%20grand%20piano%20under%20warm%20spotlight%2C%20classical%20and%20modern%20fusion%20aesthetic%2C%20golden%20warm%20tones%2C%20clean%20composition%2C%20music%20show%20poster%20style&width=800&height=450&seq=video-poster-07&orientation=landscape',
    rating: 9.3,
    year: 2026,
    quality: '1080P',
    description: '顶级美声歌者汇聚一堂，用天籁之音演绎经典与现代的完美融合，震撼心灵的视听盛宴。',
    duration: '10期',
  },
  {
    id: 8,
    title: '幻境之门',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20a%20magical%20portal%20opening%20in%20a%20lush%20forest%2C%20mystical%20creatures%20and%20floating%20crystals%2C%20warm%20golden%20and%20emerald%20tones%2C%20clean%20composition%2C%20fantasy%20anime%20poster&width=800&height=450&seq=video-poster-08&orientation=landscape',
    rating: 9.1,
    year: 2026,
    quality: '4K',
    description: '普通高中生在图书馆发现一本神秘古书，被吸入幻境世界，开启一段不可思议的奇幻冒险。',
    duration: '24集',
  },
  {
    id: 9,
    title: '极速追击',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20visual%20with%20sports%20cars%20racing%20through%20city%20streets%20at%20night%2C%20motion%20blur%20effects%2C%20warm%20neon%20lights%2C%20intense%20atmosphere%2C%20clean%20composition%2C%20action%20movie%20poster%20style&width=800&height=450&seq=video-poster-09&orientation=landscape',
    rating: 8.5,
    year: 2026,
    quality: '4K',
    description: '退役赛车手为救被绑架的女儿，重握方向盘在街头展开生死时速追击，惊险刺激全程高能。',
    duration: '118分钟',
  },
  {
    id: 10,
    title: '长安十二时辰·新篇',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20at%20sunset%20with%20lanterns%20and%20palace%20rooftops%2C%20warm%20golden%20light%2C%20historical%20drama%20aesthetic%2C%20clean%20composition%2C%20period%20drama%20poster%20style&width=800&height=450&seq=video-poster-10&orientation=landscape',
    rating: 9.4,
    year: 2026,
    quality: '1080P',
    description: '长安城中暗流涌动，各方势力角逐博弈，一场关乎王朝命运的秘密行动在十二时辰内展开。',
    duration: '48集',
  },
  {
    id: 11,
    title: '舞动奇迹·全明星',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Dance%20competition%20stage%20with%20dynamic%20dancers%20in%20colorful%20costumes%2C%20dramatic%20stage%20lighting%2C%20energetic%20vibrant%20atmosphere%2C%20clean%20composition%20on%20warm%20gradient%20background%2C%20dance%20show%20poster&width=800&height=450&seq=video-poster-11&orientation=landscape',
    rating: 8.7,
    year: 2026,
    quality: '1080P',
    description: '各路舞林高手齐聚舞台，用最燃的舞步诠释热爱，每一帧都是视觉享受。',
    duration: '12期',
  },
  {
    id: 12,
    title: '逆袭人生',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Inspiring%20drama%20movie%20visual%20of%20a%20person%20climbing%20stairs%20toward%20bright%20light%2C%20warm%20hopeful%20tones%2C%20motivational%20atmosphere%2C%20clean%20minimalist%20composition%2C%20drama%20movie%20poster%20style&width=800&height=450&seq=video-poster-12&orientation=landscape',
    rating: 8.4,
    year: 2026,
    quality: '1080P',
    description: '小镇青年凭一腔热血闯入大城市，经历挫折与成长，最终实现人生逆转的励志故事。',
    duration: '135分钟',
  },
  {
    id: 13,
    title: '元气少女缘结神·重制版',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20girl%20with%20a%20fox%20spirit%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20shojo%20anime%20poster%20style&width=800&height=450&seq=video-poster-13&orientation=landscape',
    rating: 9.0,
    year: 2026,
    quality: '4K',
    description: '经典少女动漫高清重制，少女与狐妖的奇幻恋爱故事再次感动一代观众。',
    duration: '13集',
  },
  {
    id: 14,
    title: '美食侦探',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Delicious%20food%20photography%20with%20various%20Chinese%20cuisine%20dishes%20arranged%20artistically%2C%20warm%20lighting%2C%20rich%20colors%2C%20clean%20composition%20on%20warm%20wooden%20background%2C%20food%20show%20poster%20style&width=800&height=450&seq=video-poster-14&orientation=landscape',
    rating: 8.8,
    year: 2026,
    quality: '1080P',
    description: '明星侦探团走遍全国各地，探寻隐藏在市井中的美食秘密，舌尖上的中国之旅。',
    duration: '8期',
  },
  {
    id: 15,
    title: '深海迷城',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20adventure%20movie%20visual%20with%20ancient%20ruins%20submerged%20in%20deep%20ocean%2C%20mysterious%20blue%20and%20warm%20gold%20light%20beams%2C%20epic%20scale%2C%20clean%20composition%2C%20adventure%20movie%20poster&width=800&height=450&seq=video-poster-15&orientation=landscape',
    rating: 8.9,
    year: 2026,
    quality: '4K',
    description: '深海探险队在太平洋底发现一座失落古城，未知的宝藏与危险等待着他们。',
    duration: '142分钟',
  },
  {
    id: 16,
    title: '青春纪念册',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Youth%20drama%20visual%20with%20group%20of%20students%20laughing%20in%20sunlit%20school%20campus%2C%20warm%20nostalgic%20tones%2C%20fresh%20and%20bright%20atmosphere%2C%20clean%20composition%2C%20youth%20drama%20poster%20style&width=800&height=450&seq=video-poster-16&orientation=landscape',
    rating: 8.3,
    year: 2026,
    quality: '1080P',
    description: '一群高中好友在青春岁月中经历的欢笑与泪水，友情、爱情与梦想的温暖故事。',
    duration: '24集',
  },
];